var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('v-btn',{attrs:{"disabled":_vm.isLoading,"loading":_vm.isLoading},on:{"click":_vm.testNow}},[_vm._v(" TEST NOW")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }